import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TuiTooltipModule } from '@taiga-ui/legacy';
import { TuiBadge, TuiAvatar, TuiBadgedContent, TuiBadgeNotification } from '@taiga-ui/kit';
import {
  TuiDataList,
  TuiScrollbar,
  TuiScrollable,
  TuiDropdown,
  TuiHint,
  TuiFallbackSrcPipe,
  TuiInitialsPipe,
  TuiAutoColorPipe,
} from '@taiga-ui/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ComponentsModule } from '@src/app/components';
import { LogoModule } from '@src/app/modules/logo';
import { SharedModule } from '@src/app/shared';
import { IconModule } from '@src/app/modules/icon';
import { ThemeSwitcherModule } from '@src/app/modules/theme-switcher';
import { LanguageSwitcherModule } from '@src/app/modules/language-switcher';

import { NavigationComponent } from './navigation.component';
import { NavigationDesktopComponent } from './navigation-desktop/navigation-desktop.component';
import { NavigationMobileComponent } from './navigation-mobile/navigation-mobile.component';
import { NavigationListComponent } from './navigation-list/navigation-list.component';
import { AssociationMenuComponent } from './association-menu/association-menu.component';
import { NavigationLogoComponent } from './navigation-logo/navigation-logo.component';
import { NavigationMessageComponent } from './navigation-message/navigation-message.component';
import {
  NavigationListDesktopComponent,
  NavigationListMobileComponent,
  NavigationListTabsComponent,
} from './navigation-list/components';

@NgModule({
  declarations: [
    NavigationComponent,
    NavigationDesktopComponent,
    NavigationMobileComponent,
    NavigationListComponent,
    NavigationListDesktopComponent,
    NavigationListMobileComponent,
    NavigationListTabsComponent,
    AssociationMenuComponent,
    NavigationLogoComponent,
    NavigationMessageComponent,
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    RouterModule,
    IconModule,
    LogoModule,
    NgxPermissionsModule,
    TuiAvatar,
    ...TuiBadgedContent,
    TuiBadgeNotification,
    TuiBadge,
    ...TuiDataList,
    ...TuiDropdown,
    ...TuiHint,
    TuiScrollbar,
    TuiScrollable,
    TuiTooltipModule,
    SharedModule,
    ThemeSwitcherModule,
    LanguageSwitcherModule,
    TuiFallbackSrcPipe,
    TuiInitialsPipe,
    TuiAutoColorPipe,
  ],
  exports: [
    NavigationComponent,
    NavigationListComponent,
    AssociationMenuComponent,
    NavigationLogoComponent,
    NavigationMessageComponent,
  ],
})
export class NavigationModule {}
